import { render, staticRenderFns } from "./DocumentPdfPreviewDialog.vue?vue&type=template&id=30accdf7"
import script from "./DocumentPdfPreviewDialog.vue?vue&type=script&lang=js"
export * from "./DocumentPdfPreviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports